import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './langs/index'
import './icons'
import './permission'
import '@/styles/index.scss'

import '@/directive/index.js'
import './plugins/element.js'
import '@/plugins/viewer.js'

import { hasBtnPermission } from './utils/buttonsPermission'
import { startTokenCheck } from '@/utils/auth'
// 引入开发者工具检测器
import { devToolsDetector } from '@/utils/devTools'

Vue.config.productionTip = false
Vue.prototype.hasPerm = hasBtnPermission
import VueHtml2Canvas from 'vue-html2canvas';
Vue.use(VueHtml2Canvas);

// 启动Token检查机制
let tokenCheckCleanup = null

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  mounted() {
    // 在应用挂载后启动Token检查
    if (store.getters.token) {
      tokenCheckCleanup = startTokenCheck(store)
    }
    
    // 初始化开发者工具检测器
    console.log('开发者工具检测已启动')
  },
  beforeDestroy() {
    // 在应用销毁前清理Token检查
    if (tokenCheckCleanup) {
      tokenCheckCleanup()
    }
  }
}).$mount('#app')

// 监听store中token的变化
store.watch(
  (state) => state.user.token,
  (newToken) => {
    if (newToken && !tokenCheckCleanup) {
      // 如果有token且没有启动检查，则启动
      tokenCheckCleanup = startTokenCheck(store)
    } else if (!newToken && tokenCheckCleanup) {
      // 如果没有token且有检查在运行，则停止
      tokenCheckCleanup()
      tokenCheckCleanup = null
    }
  }
)
